<template>
  <div>
    <!-- 二级分销商 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>二级分销商管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="navFrame">
      <div class="navDataBig">
        <div v-for="v in navList" :key="v.id" @click="noteTem(v.id)">
          <div>{{v.title}}</div>
          <div>
            <span>
              <span>{{v.navTotal}}</span>
              <span>{{v.unit}}</span>
            </span>
            <img :src="v.srcUrl" alt />
          </div>
        </div>
      </div>
    </div>
    <el-card>
      <div class="searRow">
        <div class="searLeft">
          <el-input placeholder="分销商名称" v-model="data.name" clearable></el-input>
          <div class="searLeftSel">
            <el-select v-model="data.status" placeholder="全部状态" clearable>
              <el-option
                v-for="item in dataOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <!-- <el-select v-model="value" placeholder="全部省份">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select> -->
          <el-button class="searBtn" @click="SeoCli">查询</el-button>
        </div>
        <div class="searRight">
          <el-button type="primary" plain @click="addRetailFn()">
            <i class="iconfont icon-jiahao"></i>
            添加分销商
          </el-button>
        </div>
      </div>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column  label="分销商名称" >
            <template slot-scope="scope">
                <span>[{{ scope.row.DistributorID }}]-</span>
                <span>{{ scope.row.Name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="yewu_mobile" label="分销商业务电话" width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.yewu_mobile">{{ scope.row.yewu_mobile }}({{ scope.row.yewu_name }})</span>
              <el-button type="text" @click="mobileFn(scope.row)" v-else>点击添加</el-button>
              <el-button type="text" @click="mobileFn(scope.row)" v-if="scope.row.yewu_mobile">修改</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Balance" label="余额"></el-table-column>
          <el-table-column prop="OverDraftMoney" label="可透支金额">
             <template slot-scope="scope">
                <!-- <el-input v-model="scope.row.OverDraftMoney" @blur="MoneyChange(scope.row)"></el-input> -->
                <span>{{ scope.row.OverDraftMoney }}</span>
             </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" width="285"    fixed="right">
            <template slot-scope="scope">
                <div class="tab_flex_cell">
                  <el-button type="text" @click="dataAuthorFn(scope.row)">期票授权</el-button>
              <el-button type="text" @click="caldarTctFn(scope.row)">日历票授权</el-button>
              <el-button type="text" @click="RechargeFn(scope.row)">充值</el-button>
              <el-button type="text" @click="addRetailFn(scope.row)">详情</el-button>
              <!-- <el-button type="text" style="color: #FF4D4F;" >删除</el-button> -->
              <el-popconfirm
              confirm-button-text='确认'
              cancel-button-text='取消'
              icon="el-icon-info"
              icon-color="red"
              title="是否删除该分销商"
              @confirm="confirms(scope.row)"
            >
              <div slot="reference" style="cursor:pointer;">
                删除
              </div>
            </el-popconfirm>
                </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{data.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="data.total" :current-page="data.page" @current-change="curren"></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 添加分销商开始 -->
    <addRetail v-if="addRetailvisible" ref="addRetailDialog" @HandleClose="RetailClose"></addRetail>
    <!-- 添加分销商结束 -->
    <!-- 期票授权修改开始 -->
    <dataAuthorDialog v-if="dataAuthorvisible" ref="dataAuthorDialog" @impowerClose="closePo"></dataAuthorDialog>
    <!-- 期票授权修改结束 -->
    <!-- 日历票授权开始 -->
    <caldarTctDialog v-if="caldarTctvisible" ref="caldarTctDialog" :row="row" @Distrbutor="closeButor"></caldarTctDialog>
    <!-- 日历票授权结束 -->

    <!-- 联系人添加弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="mobilTitle"
      :visible.sync="mobileDialogVisible"
      :before-close="mobileHandleClose"
      width="21.4%"
      center
      top="30vh"
    >
      <el-divider></el-divider>

      <el-form ref="form" :model="form" :rules="formRule" label-width="100px">
        <div class="formItem">
          <el-form-item label="姓名:" prop="name">
            <el-input v-model="form.name" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系电话:" prop="mobile">
            <el-input v-model="form.mobile" placeholder="联系电话"></el-input>
          </el-form-item>
          <el-form-item class="itemBtnS">
            <el-button @click="phoneclear">清空</el-button>
            <el-button class="btnL" @click="TwoList('form')">确认保存</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
    <!-- 联系人添加弹框结束 -->
    <!-- 充值弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="充值"
      :visible.sync="RechargeDialogVisible"
      :before-close="RechargeHandleClose"
      width="40%"
      center
      top="30vh"
    >
      <el-divider></el-divider>
      <div class="RechargeContent">
        <el-form ref="Recharge" :model="Recharge"  label-width="75px">
          <div class="RechargeItem">
            <el-form-item label="当前余额:">
              <el-input v-model="BalanceMoney" disabled></el-input>
            </el-form-item>
            <el-form-item label="充值金额:" prop="money">
              <el-input v-model="Recharge.money" type="number" placeholder="请输入充值金额" @input="checkMoney"></el-input>
            </el-form-item>
            <el-form-item class="itemBtnS">
              <el-button @click="RechargeCl">充值</el-button>
            </el-form-item>
          </div>
        </el-form>
        <div>
          <el-table
            :data="tableData1"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            style="width: 100%"
          >
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column prop="PayTime" label="充值时间"></el-table-column>
            <el-table-column prop="Pay" label="充值金额"></el-table-column>
            <el-table-column prop="Balance" label="余额"></el-table-column>
            <el-table-column prop="UserID" label="操作人"></el-table-column>
          </el-table>
        </div>
        <!-- 分页开始 -->
        <div class="pagination">
        <span class="demonstration">共{{data1.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data1.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="data1.total" :current-page="data1.page" @current-change="curren1"></el-pagination>
      </div>
      </div>
      <!-- 分页结束 -->
    </el-dialog>
    <!-- 充值弹框结束 -->
    
  </div>
</template>

<script>
import addRetail from "./dialog/addRetail.vue";
import caldarTctDialog from "./dialog/caldarTctDialog.vue";
import dataAuthorDialog from "./dialog/dataAuthorDialog.vue";
import { Message } from "element-ui";
import {deleteDistributortwo,getDistrbutorTwoCount,
  getImpowerDistrbutorTwoList,addDistributorTwoYeWuInfo,
  rechargeDistrbutorTwoRecord,rechargeDistrbutorTwo,updateDistrbutorTwoOverDraftMoney} from "@/request/distributor.js"

export default {
  components: {
    addRetail,
    caldarTctDialog,
    dataAuthorDialog
  },
  data() {
    return {
      row:'',
      options: [     
      ],
      value: "",
      value3: "",
      tableData: [
      ],
      input: "",
      mobileDialogVisible: false, // 订单详情
      addRetailvisible: false, // 添加分销商详情
      RechargeDialogVisible: false, // 充值
      caldarTctvisible: false, // 日历票授权
      dataAuthorvisible: false, // 期票授权
      mobilTitle: "", // 联系人添加修改
      navList: [
        {
          id: 1,
          title: "分销商开通总数",
          navTotal: 83178,
          srcUrl: require("@/images/scenic/kt.png"),
          unit: "家"
        },
        {
          id: 2,
          title: "自主接入分销商",
          navTotal: 83178,
          srcUrl: require("@/images/scenic/jr.png"),
          unit: "家"
        },
        {
          id: 3,
          title: "共享系统分销商",
          navTotal: 83178,
          srcUrl: require("@/images/scenic/gx.png"),
          unit: "家"
        },
        {
          id: 4,
          title: "分销商库总数",
          navTotal: 83178,
          srcUrl: require("@/images/scenic/k.png"),
          unit: "家"
        }
      ],
      data:{
        name:'',
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:8,
        total:1,
        status:''
      },
      dataOption:[
      {
          value:'1',
          label:'上线'
        },
        {
          value:'2',
          label:'下线'
        }
      ],
      form: {
        name: "",
        mobile:'',
        token:window.sessionStorage.getItem('Token'),
        distributortwoid:''
      },
      formRule:{
        name:[{ required: true, message: '请输入分销商业务名称', trigger: 'blur' }],
        mobile:[   { required: true, message: '请输入手机号码', trigger: 'change' },
           {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              var passwordreg = /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/
              if (!passwordreg.test(value)) {
                callback(
                  new Error(
                    '请输入正确的手机号码哦!'
                  )
                )
              } else {
                callback()
              }
            }
          }]
      },
      Recharge:{
        distrbutortwo_id:'',
        money:"",
        token:window.sessionStorage.getItem('Token'),
      },
      data1:{
        token:window.sessionStorage.getItem('Token'),
        distrbutortwo_id:'',
        page:1,
        page_size:8,
        total:1
      },
      tableData1:[],
      BalanceMoney:''
    };
  },
  created(){
    this.getList()
    this.getDetail()
  },

  methods: {
    MoneyChange(i){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        d_two_id:i.DistributorID,
        money:i.OverDraftMoney
      }
      updateDistrbutorTwoOverDraftMoney(data).then(res=>{
        if(res.data.status=='ok'){
          this.getList()
          this.$message.success('修改成功')
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    phoneclear(){
       this.form.name = ''
       this.form.mobile = ''
    },
    checkMoney(e){
      this.Recharge.money = (e.match(/^\d*(\.?\d{0,2})/g)[0]) || null
    },
    // 删除
    confirms(row){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        distributortwoid:row.DistributorID
      } 
      deleteDistributortwo(data).then(res=>{
        if(res.data.status=='ok'){
          this.getList()
          this.getDetail()
          this.$message.success('删除成功')
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    getDetail(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      getDistrbutorTwoCount(data).then(res=>{
        if(res.data.status=='ok'){
          res.data.result.map(item=>{
            this.navList.map(itm=>{
              if(itm.title==item.name){
                itm.navTotal = item.count
              }
            })
          })
        }
      })
    },
    // 二级分销商列表
    getList(){
      getImpowerDistrbutorTwoList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.data.total = res.data.result.total
        }else{
          this.tableData = res.data.result.data
          this.data.total = res.data.result.total
        }
      })
    },
    // 二级分销商查询
    SeoCli(){
      this.data.page = 1
      this.getList()
    },
    // 二级分销商分页
    curren(e){
      this.data.page = e
      this.getList()
    },
    // 添加修改手机号
    TwoList(form){
      this.$refs['form'].validate((valid) => {
          if (valid) {
            addDistributorTwoYeWuInfo(this.form).then(res=>{
              if(res.data.status=='ok'){
                this.$message.success('保存成功')
                this.mobileDialogVisible  = false
                this.getList()
              }else{
                Message.error(res.data.msg)
              }
            })
          }
      });
    },
    // 充值分页
    curren1(e){
      this.data1.page = e
      this.rechargeList()
    },
    // 充值列表
    rechargeList(){
      rechargeDistrbutorTwoRecord(this.data1).then(res=>{
          if(res.data.status=='ok'){
            this.tableData1 = res.data.result.data
            this.data1.total = res.data.result.total
          }
      })
    },
    // 确认充值
    RechargeCl(){
          rechargeDistrbutorTwo(this.Recharge).then(res=>{
            if(res.data.status=='ok'){
              this.getList()
              this.RechargeDialogVisible = false;
              this.$message.success('充值成功')
            }else{
              Message.error(res.data.msg)
            }
      })
    },
    // 期票授权
    dataAuthorFn(row) {
      this.dataAuthorvisible = true;
      this.$nextTick(() => {
        this.$refs.dataAuthorDialog.dataAuthor(row);
      });
    },
    closePo(){
      this.dataAuthorvisible = false
    },
    // 日历票授权
    caldarTctFn(row) {
      this.caldarTctvisible = true;
      this.row =row
      this.$nextTick(() => {
        this.$refs.caldarTctDialog.caldarTct(row);
      });
    },
    // 关闭日历票弹框
    closeButor(){
      this.caldarTctvisible = false
    },
    // 点击充值
    RechargeFn(row) {
      this.Recharge.money = ''
      this.BalanceMoney = row.Balance
      this.Recharge.distrbutortwo_id = row.DistributorID
      this.data1.distrbutortwo_id = row.DistributorID
      this.rechargeList()
      this.RechargeDialogVisible = true;
    },
    // 点击充值X
    RechargeHandleClose() {
      this.RechargeDialogVisible = false;
    },
    // 联系人添加
    mobileFn(row) {
      console.log(row)
      this.form.distributortwoid = row.DistributorID
      if (row.yewu_mobile) {
        this.mobilTitle = "修改联系人";
        this.form.name = row.yewu_name
        this.form.mobile = row.yewu_mobile
      } else {
        this.mobilTitle = "添加联系人";
        this.form.name = row.yewu_name
        this.form.mobile = row.yewu_mobile
      }
      this.mobileDialogVisible = true;
    },
    // 联系人添加X
    mobileHandleClose() {
      this.mobileDialogVisible = false;
    },
    // 添加分销商
    addRetailFn(row) {
      this.addRetailvisible = true;
      this.$nextTick(() => {
        this.$refs.addRetailDialog.addRetail(row);
      });
    },
    // 关闭分销商详情
    RetailClose(){
      this.addRetailvisible = false
      this.getList()
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.authorTable {
  .el-input {
    width: 100px;
    height: 30px;
  }
  /deep/.el-input__inner {
    -webkit-appearance: none;
    background: #f7f7fa;
    border-radius: 4px;
    border: none;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 30px;
    line-height: 30px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
    text-align: center;
  }
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 20px auto 0px;
  }
}
.RechargeContent {
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 20px auto 0px;
  }
  .RechargeItem {
    display: flex;
    flex-wrap:wrap ;
    .el-form-item {
      margin-right: 20px;
    }
    .el-input {
      width: 200px;
    }
    .itemBtnS {
      .el-button {
        width: 100px;
        background: #246deb;
        border-radius: 4px;
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
        border: none;
        margin-left: -75px;
      }
    }
  }
}
.searRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
  .searLeft {
    display: flex;
    flex-wrap: wrap;
    .el-input {
      width: 240px;
      margin:0 20px 10px 0 ;
    }
    .searLeftSel {
      margin:0 20px 10px 0 ;
    }
    .el-select {
      width: 260px;
      margin:0 20px 10px 0 ;
    }
    .searBtn {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      box-sizing: border-box;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      margin:0 20px 20px 0 ;

    }
  }
  .el-button {
    width: 136px;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #246deb;
  }
}
.btn {
  display: flex;
  justify-content: center;
  margin: 40px 0 30px 0;
  /deep/.el-button {
    width: 100px;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
    background: #ffffff;
  }
}
.conentCenter {
  .printImg {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .printContent {
    width: 400px;
    //   height: 492px;
    padding: 0 20px;
    box-sizing: border-box;
    margin: auto;
    // border: 1px double #246deb;
    position: absolute;
    top: 82px;
    left: 41px;
    > div:nth-child(1) {
      height: 64px;
      line-height: 64px;
      text-align: center;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      /* identical to box height */
      color: #000000;
      border-bottom: 2px double #c4c4c4;
    }
    > div:nth-child(2) {
      margin-top: 18px;
      /deep/.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
        padding-bottom: 15px;
      }
      /deep/.el-descriptions-item__label {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        text-align: right;

        color: #666666;
      }
      /deep/.el-descriptions-item__content {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;

        color: #000000;
      }
    }
    > div:nth-child(3) {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #e74c3c;
      margin: 10px 0 20px 0;
    }
  }
}
.btns {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  .el-button {
    width: 100px;
    height: 40px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;

    color: #246deb;
  }
  .btnL {
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;

    color: #ffffff;
  }
}
.formItem {
  // .el-input {
  //   width: 300px;
  // }
  .itemBtnS {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-left: -75px;
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
}

.navFrame {
  width: 100%;
  display: flex;
  margin: 17px 0;
  flex-wrap: wrap;
  .navDataBig {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    > div {
      width: 24%;
      min-width: 250px;
      height: 150px;
      background: #ffffff;
      border-radius: 4px;
      margin:0 15px 10px 0;
      > div:nth-child(1) {
        height: 20px;
        margin-left: 20px;
        margin-top: 17px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */

        color: #666666;
      }
      > div:nth-child(2) {
        height: 56px;
        display: flex;
        margin-top: 40px;
        // background: red;
        img {
          width: 80px;
          height: 60px;
          margin-right: 20px;
        }
        span {
          width: 100%;
          height: 100px;
          margin-bottom: 20px;
          display: flex;
          > span:nth-child(1) {
            display: block;
            width: 120px;
            height: 100%;
            line-height: 100px;
            margin-left: 21px;
            margin-right: 8px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 600;
            font-size: 40px;
            line-height: 56px;
            /* identical to box height */
            color: #246deb;
          }
          > span:nth-child(2) {
            display: block;
            width: 20px;
            height: 100%;
            margin-top: 20px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            /* identical to box height */
            color: #797979;
          }
        }
      }
    }
  }
}
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}
/deep/.el-dialog__headerbtn {
  position: absolute;
  top: 0px;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
.RechargeItem{
  width: 100%;
}
.tab_flex_cell {
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-popover__reference{
  margin-left: 1rem;
  color:#FF4D4F;
}
/deep/ input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  /deep/ .el-dialog{
    min-width: 400px;
  }
  /deep/ .el-table__cell{
    text-align: left !important;
  }
  .RechargeContent {
    /deep/.is-disabled input{
      background: #fff;
      color: #666666;
    }
  }
</style>